import { render, staticRenderFns } from "./static-text-widget.vue?vue&type=template&id=0b136461&scoped=true&"
import script from "./static-text-widget.vue?vue&type=script&lang=js&"
export * from "./static-text-widget.vue?vue&type=script&lang=js&"
import style0 from "./static-text-widget.vue?vue&type=style&index=0&id=0b136461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b136461",
  null
  
)

export default component.exports